export default __webpack_public_path__ + "static/media/overlay-gradient.ae704b9f.svg";